import React, { Fragment } from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { SectionHeader, Card } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes/Provider';

import styles from '../AppSettings.Styles';

const SectionContainer = ({ children, isCard, theme, isRadio = null, ...props }) => {
  if (isCard && !isRadio) {
    return <Card {...props}>{children}</Card>;
  }
  if (isRadio) {
    return (
      <View style={{
        backgroundColor: theme.colors.cardBackgroundColor,
        height: 'auto', borderRadius: 6, elevation: 5,
        shadowColor: 'rgba(0, 0, 0, 0.16)',
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowRadius: 4,
        shadowOpacity: 1,
        padding: 20
      }}>{children}</View>
    )
  }


  return <Fragment key={props.key}>{children}</Fragment>;
};

SectionContainer.propTypes = {
  children: PropTypes.node.isRequired,
  key: PropTypes.string,
  isCard: PropTypes.bool.isRequired,
};

function AppSetting({ setting, theme, images }) {
  return (
    <View style={styles.sectionContainer}>
      {setting.title && (
        <SectionHeader
          theme={theme}
          title={setting.title}
          subtitle={setting.description}
          illustrationImage={images[setting.illustrationImage]}
          illustrationImageStyle={setting.illustrationImageStyle}
          isRadio={setting?.isRadio}
        />
      )}

      <SectionContainer style={styles.containerStyle(theme)} isCard={setting.withCard}>
        {setting.items.map((item, subIndex) => (
          <Fragment key={item.component?.name || subIndex}>
            <item.component {...item.props} images={images} />

            {setting.withCard &&
              setting.items.length > 1 &&
              subIndex !== setting.items.length - 1 && <View style={styles.divider(theme)} />}
          </Fragment>
        ))}
      </SectionContainer>
    </View>
  );
}

AppSetting.defaultProps = {
  theme: LightThemeColors,
};

AppSetting.propTypes = {
  setting: PropTypes.object.isRequired,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  images: PropTypes.object,
};

export default withTheme(AppSetting);
